// Topbar Search — show/hide results dropdown
// ========================================================================

(function() {
  var SEARCH_ID = 'topbar-search';
  var RESULTS_ID = 'topbar-search-results';
  var loaderTimeout;

  function getSearch() { return document.getElementById(SEARCH_ID); }
  function getResults() { return document.getElementById(RESULTS_ID); }
  function getInput() {
    var search = getSearch();
    return search ? search.querySelector('input[name="q"]') : null;
  }

  function showResults() {
    var results = getResults();
    if (results && results.innerHTML.trim()) {
      results.classList.add('show');
    }
  }

  function hideResults() {
    var results = getResults();
    if (results) results.classList.remove('show');
  }

  function removeLoader() {
    clearTimeout(loaderTimeout);
    var loader = document.getElementById('topbar-search-loading');
    if (loader) loader.remove();
  }

  // After any HTMX swap anywhere on the page
  document.body.addEventListener('htmx:afterSwap', function(e) {
    var results = getResults();
    if (!results) return;

    // Shell just loaded into results target
    if (e.detail.target === results) {
      showResults();
      // Fallback: if no results arrive within 3s, show "no results"
      clearTimeout(loaderTimeout);
      loaderTimeout = setTimeout(function() {
        var loader = document.getElementById('topbar-search-loading');
        // Only show "no results" if the loader still exists AND no actual results loaded
        if (loader && !results.querySelector('.rf-list-group-item--action')) {
          loader.innerHTML = '<div class="rf-list-item-content"><div class="rf-list-item-description">No results found</div></div>';
        } else if (loader) {
          loader.remove();
        }
      }, 3000);
      return;
    }

    // Swap targeting page content (tab switch, filter, navigation) — hide search
    if (e.detail.target.id === 'page-content' || e.detail.target.closest('#page-content')) {
      hideResults();
      return;
    }

    // Any other swap (e.g. search result items loading) — show results if content exists
    if (results.querySelector('.rf-list-group-item--action')) {
      removeLoader();
    }
    showResults();
  });

  // Hide on click outside
  document.addEventListener('click', function(e) {
    if (!(e.target instanceof Element)) return;
    var search = getSearch();
    if (search && !search.contains(e.target)) hideResults();
  });

  // Hide on Escape
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      hideResults();
      var input = getInput();
      if (input) input.blur();
    }
  });

  // Show on focus if results exist
  document.addEventListener('focusin', function(e) {
    var input = getInput();
    if (input && e.target === input) showResults();
  });

  // Navigate [data-href] elements inside search results (avoids nested <a> / inline onclick)
  document.addEventListener('click', function(e) {
    if (!(e.target instanceof Element)) return;
    var el = e.target.closest('[data-href]');
    var results = getResults();
    if (el && results && results.contains(el)) {
      e.preventDefault();
      e.stopPropagation();
      window.location = el.getAttribute('data-href');
    }
  });

  // Clear on empty input
  document.addEventListener('input', function(e) {
    var input = getInput();
    if (input && e.target === input && !input.value.trim()) {
      hideResults();
      clearTimeout(loaderTimeout);
      var results = getResults();
      if (results) results.innerHTML = '';
    }
  });

  // Mobile search open/close
  function closeMobileSearch() {
    var search = getSearch();
    if (!search) return;
    search.classList.remove('topbar__search--open');
    hideResults();
    var input = getInput();
    if (input) input.value = '';
    var results = getResults();
    if (results) results.innerHTML = '';
  }

  var toggle = document.getElementById('topbar-search-toggle');
  if (toggle) {
    toggle.addEventListener('click', function() {
      var search = getSearch();
      if (!search) return;
      var isOpen = search.classList.toggle('topbar__search--open');
      if (isOpen) {
        var input = getInput();
        if (input) input.focus();
      } else {
        closeMobileSearch();
      }
    });
  }

  var closeBtn = document.getElementById('topbar-search-close');
  if (closeBtn) {
    closeBtn.addEventListener('click', closeMobileSearch);
  }

  // Close mobile search on Escape
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      var search = getSearch();
      if (search && search.classList.contains('topbar__search--open')) {
        closeMobileSearch();
      }
    }
  });
})();
